<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM11 19.95V18C10.45 18 9.97933 17.8043 9.588 17.413C9.196 17.021 9 16.55 9 16V15L4.2 10.2C4.15 10.5 4.104 10.8 4.062 11.1C4.02067 11.4 4 11.7 4 12C4 14.0167 4.66267 15.7833 5.988 17.3C7.31267 18.8167 8.98333 19.7 11 19.95ZM17.9 17.4C18.2333 17.0333 18.5333 16.6373 18.8 16.212C19.0667 15.7873 19.2877 15.3457 19.463 14.887C19.6377 14.429 19.771 13.9583 19.863 13.475C19.9543 12.9917 20 12.5 20 12C20 10.3667 19.546 8.875 18.638 7.525C17.7293 6.175 16.5167 5.2 15 4.6V5C15 5.55 14.8043 6.02067 14.413 6.412C14.021 6.804 13.55 7 13 7H11V9C11 9.28333 10.9043 9.52067 10.713 9.712C10.521 9.904 10.2833 10 10 10H8V12H14C14.2833 12 14.521 12.0957 14.713 12.287C14.9043 12.479 15 12.7167 15 13V16H16C16.4333 16 16.825 16.129 17.175 16.387C17.525 16.6457 17.7667 16.9833 17.9 17.4Z"
      fill="#F18E35"
    />
  </svg>
</template>

<script>
export default {
  name: "WebCateringIcon",
};
</script>

<style scoped></style>
